import React, { Component } from "react";
import axios from 'axios';

import { ConsentForm } from "../../components/ConsentForm/ConsentForm";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import './style.css';
import { Header } from "../../components/Header";
import { CourseInfo } from "../../components/CourseInfo/CourseInfo";
import { CourseLandingImageGallery } from "../../components/CourseLandingImageGallery";
import { CourseLandingViewMore } from "../../components/CourseLandingViewMore";
import { CourseFeaturesList } from '../../components/CourseFeaturesList';
import { UnderlinedTitle } from '../../components/UnderlinedTitle';
import { CourseSectionSelector } from "../../components/CourseSectionSelector/CourseSectionSelector";
import withRouter from '../../withRouter';
import { CourseLandingLoopVideo } from "../../components/CourseLandingLoopVideo";
import { CourseLandingHeaderInfo } from "../../components/CourseLandingHeaderInfo";
import { CourseLandingTeachers } from "../../components/CourseLandingTeachers";

import { CourseFAQ } from "../../components/CourseFAQ";
import { CourseLandingWhatsIncluded } from "../../components/CourseLandingWhatsIncluded";

import { CourseLandingContentSection } from "../../components/CourseLandingContentSection";
import { CourseReviews } from "../../components/CourseReviews/CourseReviews";
import { HighlightedCourseReviews } from "../../components/HighlitedCourseReviews";
import { CourseLandingCertificate } from "../../components/CourseLandingCertificate"

import { CourseLandingSponsors } from "../../components/CourseLandingSponsors";

import { Footer } from "../../components/Footer/Footer";
import { HubInfo } from "../../components/HubInfo";

class CourseLanding extends Component {

  handleExpand = (index) => {
    this.setState((prevState) => ({
      expandedIndex: prevState.expandedIndex === index ? null : index,
    }));
  };

  constructor(props) {

    super(props);

    this.state = {
      expandedIndex: null,
      current_section: "overview",
      page_title: "",
      course_title: "",
      course_teacher_name: "...... .......",
      course_type: ".........",
      teacher_bio: null,
      teachers_bio: [],
      packshot_image: "https://newmedia.10masters.com/images/packshot.max-1000x1000.format-webp.webp",
      course_undertitle_text: "........ ........... ............. ...........",
      intro_text: "",
      intro_text_hidden: "",
      outro_text: "",
      outro_text_hidden: "",
      outro_title: "",
      artist_quote_text: "",
      artist_quote_name: "",
      course_has_certificate: true,
      cover_loop_mobile: "",
      cover_loop: "",
      cover_loop_mobile_image: "",
      cover_loop_image: "",
      cover_loop_video_mobile: "",
      cover_loop_video: "",
      cover_loop_video_subtitles_dir: "",
      course_section_blocks: [],
      whats_included_list: null,
      whats_included_images: null,
      faq_blocks: [],
      original_price: "",
      number_lessons_text: "",
      audio_languages_text: "",
      under_price_text: "........ ........ ... ..........",
      under_price_animals_text: "........ .... ........ ..........",
      course_level_text: "",
      subtitles_languages_text: "",
      under_action_button_text: ".......... ....... ........ ... ..........",
      current_price: "",
      product_id: "",
      already_bought: false,
      num_reviews: false,
      reviews_product_id: null,
      logged_in: false,
      animals_discount: false,
      fb_event_id: "",
      external_id: [],
      sponsors_image: null,
      latest_works: [],
      presale: false,
      page_loaded: false,
      user_countrycode: "US",
      countdownRemainingTime: 0,

      //reveal_sections: false,
      topPriceShown: false,

      mostrarPopup: false,
      discount_message: ""
    };


    this.translations = {
      "en": {
        "with": "with",
        "lastworks": "Take a look at my last tattoos:",
        "course_landing_reviews_text": 'Only members enrolled in the Mastercourse are able to leave a review. Check our Instagram reviews in the <a href="https://instagram.com/10masters" rel="noreferrer" target="_blank">Highlighted Stories of our account</a>.',
        "faq_title": "FREQUENTLY ASKED QUESTIONS",
        "ratings_title": "REVIEWS",
        "highlighted_reviews": "HIGHLIGHTED REVIEWS",
        "get_all_content": "VIEW ALL CONTENT",
        "hide_all_content": "HIDE CONTENT",
        "sponsors_prefix": "",
        "sponsors_sufix": " sponsors:",
        "blackweek_banner": document.body.clientWidth >= 768 ? "https://newmedia.10masters.com/images/Buy_any_course_and_get_Blackw.max-1980x1200.format-webp_6rkF44G.webp" : "https://newmedia.10masters.com/images/Buy_any_course_and_get_Blackw.max-1980x1200.format-webp.webp"
      },
      "es": {
        "with": "con",
        "lastworks": "Echa un vistazo a mis últimos trabajos:",
        "course_landing_reviews_text": 'Todas las valoraciones están verificadas y sólo pueden publicarlas los usuarios que han finalizado el curso. Si quieres ver reseñas en Instagram, puedes visitar nuestros <a href="https://instagram.com/10masters_es" rel="noreferrer" target="_blank">Stories destacados</a>.',
        "faq_title": "PREGUNTAS FRECUENTES",
        "ratings_title": "RESEÑAS",
        "highlighted_reviews": "RESEÑAS DESTACADAS",
        "get_all_content": "VER TODO EL CONTENIDO",
        "hide_all_content": "OCULTAR CONTENIDO",
        "sponsors_prefix": "Sponsors de ",
        "sponsors_sufix": ":",
        "blackweek_banner": document.body.clientWidth >= 768 ? "https://newmedia.10masters.com/images/Compra_cualquier_curso_y_llev.max-1980x1200.format-webp_V8z6RKe.webp" : "https://newmedia.10masters.com/images/Compra_cualquier_curso_y_llev.max-1980x1200.format-webp.webp"
      },
      "pt": {
        "with": "com",
        "lastworks": "Dê uma olhada nos meus últimos trabalhos:",
        "course_landing_reviews_text": 'Todas as avaliações são verificadas e só podem ser publicadas por utilizadores que tenham concluído o curso. Se quiser ver comentários no Instagram, pode visitar as nossas <a href="https://instagram.com/10masters" rel="noreferrer" target="_blank">Stories em destaque</a>.',
        "faq_title": "PREGUNTAS FREQUENTES",
        "ratings_title": "CLASSIFICAÇÕES",
        "highlighted_reviews": "CLASSIFICAÇÕES DESTACADAS",
        "get_all_content": "VER TODO O CONTEÚDO",
        "hide_all_content": "OCULTAR CONTEÚDO",
        "sponsors_prefix": "Sponsors de ",
        "sponsors_sufix": ":",
        "blackweek_banner": document.body.clientWidth >= 768 ? "https://newmedia.10masters.com/images/Compre_qualquer_curso_e_receb.max-1980x1200.format-webp_KpdRcs7.webp" : "https://newmedia.10masters.com/images/Compre_qualquer_curso_e_receb.max-1980x1200.format-webp.webp"
      },
      "fr": {
        "with": "avec",
        "lastworks": "Jetez un œil à mes dernières tatouages:",
        "course_landing_reviews_text": 'Tous les avis sont vérifiés et ne peuvent être postés que par des utilisateurs ayant suivi la formation. Si vous souhaitez voir des avis sur Instagram, vous pouvez consulter nos <a href="https://instagram.com/10masters" rel="noreferrer" target="_blank">Stories mises en avant</a>.',
        "faq_title": "QUESTIONS FRÉQUENTES",
        "ratings_title": "NOTES",
        "highlighted_reviews": "REVUES MISES EN EXERGUE",
        "get_all_content": "VOIR TOUT LE CONTENU",
        "hide_all_content": "MASQUER LE CONTENU",
        "sponsors_prefix": "Sponsors de ",
        "sponsors_sufix": ":",
        "blackweek_banner": document.body.clientWidth >= 768 ? "https://newmedia.10masters.com/images/Achetez_nimporte_quel_cours_e.max-1980x1200.format-webp_dVDIOx5.webp" : "https://newmedia.10masters.com/images/Achetez_nimporte_quel_cours_e.max-1980x1200.format-webp.webp"
      },
      "ru": {
        "with": "с",
        "lastworks": "Посмотрите на мои последние работы:",
        "course_landing_reviews_text": 'Только участники курса могут оставить отзыв. Ознакомьтесь с нашими отзывами в Instagram в <a href="https://instagram.com/10masters" rel="noreferrer" target="_blank">Избранных историях нашего аккаунта</a>.',
        "faq_title": "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ",
        "ratings_title": "ОТЗЫВЫ",
        "highlighted_reviews": "ИЗБРАННЫЕ ОТЗЫВЫ",
        "get_all_content": "ПОСМОТРЕТЬ ВСЕ СОДЕРЖАНИЕ",
        "hide_all_content": "СКРЫТЬ СОДЕРЖАНИЕ",
        "sponsors_prefix": "",
        "sponsors_sufix": " спонсоры:",
        "blackweek_banner": document.body.clientWidth >= 768 ? "https://newmedia.10masters.com/images/Buy_any_course_and_get_Blackw.max-1980x1200.format-webp_6rkF44G.webp" : "https://newmedia.10masters.com/images/Buy_any_course_and_get_Blackw.max-1980x1200.format-webp.webp"
      }
    };

    this.setCurrentSection = this.setCurrentSection.bind(this);

    this.setTopPriceShown = this.setTopPriceShown.bind(this);

    //this.revealSections = this.revealSections.bind(this);
    //this.unrevealSections = this.unrevealSections.bind(this);
    //this.handleScroll = this.handleScroll.bind(this);


  }


  // Función para mostrar el popup
  mostrarPopupFuncion = () => {
    this.setState({ mostrarPopup: true });
  };

  // Función para cerrar el popup
  cerrarPopupFuncion = () => {
    this.setState({ mostrarPopup: false });
  };






  getTrans(text) {

    return this.translations[this.props.language][text];

  }

  handleScroll() {

    //const overview_offset = document.getElementById('overview').offsetTop;
    const content_offset = document.getElementById('scontent').offsetTop;
    const reviews_offset = document.getElementById('reviews').offsetTop;

    let current_section = "overview";

    if ((window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) > content_offset - 140) {
      current_section = "scontent";
    }

    if ((window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) > reviews_offset - 140) {
      current_section = "reviews";
    }

    if (this.state.current_section !== current_section)
      this.setState({ current_section: current_section });

    //console.info(current_section);

  }

  handleResize = () => {
    console.info("Window resized");

    // Desktop or not // 768
    this.setState({
      isMobile: (document.body.clientWidth <= 1199),
      //isLandscape: window.innerWidth > 0 ? (window.innerWidth > window.innerHeight) : !(document.body.clientWidth <= 1199) // Get from inner... or failback to mobile, reversed (!)
      isLandscape: document.body.clientWidth >= 768,
    });
  };

  componentWillUnmount() {
    console.info("Remove resize event listener");
    window.removeEventListener('resize', this.handleResize);
  }

  getQueryParam = (name) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get(name);
  };


  componentDidMount() {

    console.info("Create resize event listener");
    window.addEventListener('resize', this.handleResize);

    // Obtener el valor del parámetro ref
    const refcode = this.getQueryParam('ref');

    // Obtener el valor del parámetro voucher_code
    const voucherCodeFromUrl = this.getQueryParam('voucher_code');

    let extraGet = "";
    // Si el parámetro existe, establecer la cookie
    if ( voucherCodeFromUrl ) {
      extraGet = "&voucher_code=" + voucherCodeFromUrl;
    }

    if ( refcode ) {
      extraGet = "&ref=" + refcode;
    }

    const slug = this.props.params.courseSlug.replace('-new', '');

    // Desktop or not // 768
    this.setState({
      isMobile: (document.body.clientWidth <= 1199),
      //isLandscape: window.innerWidth > 0 ? (window.innerWidth > window.innerHeight) : !(document.body.clientWidth <= 1199) // Get from inner... or failback to mobile, reversed (!)
      isLandscape: document.body.clientWidth >= 768,
    });

    this.getCourseInfo(slug, this.props.language, extraGet);


    if (refcode) {
      document.cookie = `refcode=${refcode}; expires=${new Date(Date.now() +  24 * 60 * 60 * 1000).toUTCString()}; path=/`;
      console.info("Cookie for refcode set to " + refcode);
    }


    // GET AND APPLY VOUCHER COOKIES FROM GET

    // Si el parámetro existe, establecer la cookie
    if (voucherCodeFromUrl) {
      // Establecer la cookie con el valor del parámetro voucher_code
      document.cookie = `voucher_code=${voucherCodeFromUrl}; expires=${new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString()}; path=/`;
      console.info("Cookie for voucher_code set to " + voucherCodeFromUrl);

    }


    //window.addEventListener('scroll', this.handleScroll);

    //return () => {
    //  window.removeEventListener('scroll', handleScroll);
    //}

  }

  selectRecord(records, user_country, user_continent) {

    // Force by hashtag
    if (document.URL.indexOf("#") > -1) {

      var hash = document.URL.substring(document.URL.indexOf("#") + 1);

      if (hash.startsWith("eur"))
        return { "currency": "EUR", "record": records["EUR"] };

      if (hash.startsWith("usd"))
        return { "currency": "USD", "record": records["USD"] };

      if (hash.startsWith("mxn"))
        return { "currency": "MXN", "record": records["MXN"] };

      if (hash.startsWith("brl"))
        return { "currency": "BRL", "record": records["BRL"] };

      if (hash.startsWith("cop"))
        return { "currency": "COP", "record": records["COP"] };

      if (hash.startsWith("clp"))
        return { "currency": "CLP", "record": records["CLP"] };

      //if (hash.startsWith("ars"))
      //  return { "currency": "ARS", "record": records["ARS"] };

      if (hash.startsWith("uyu"))
        return { "currency": "UYU", "record": records["UYU"] };

      if (hash.startsWith("gbp"))
        return { "currency": "GBP", "record": records["GBP"] };

      if (hash.startsWith("cad"))
        return { "currency": "CAD", "record": records["CAD"] };

      if (hash.startsWith("aud"))
        return { "currency": "AUD", "record": records["AUD"] };

      if (hash.startsWith("rub"))
        return { "currency": "RUB", "record": records["RUB"] };

    }

    // By Country / Continent
    if (user_country === "United Kingdom")
      return { "currency": "GBP", "record": records["GBP"] };

    if (user_continent === "Europe")
      return { "currency": "EUR", "record": records["EUR"] };

    if (user_country === "Mexico")
      return { "currency": "MXN", "record": records["MXN"] };

    if (user_country === "Brazil")
      return { "currency": "BRL", "record": records["BRL"] };

    if (user_country === "Colombia")
      return { "currency": "COP", "record": records["COP"] };

    if (user_country === "Chile")
      return { "currency": "CLP", "record": records["CLP"] };

    if (user_country === "Argentina")
      return { "currency": "USD", "record": records["USD"] };
      //return { "currency": "ARS", "record": records["ARS"] };

    if (user_country === "Uruguay")
      return { "currency": "UYU", "record": records["UYU"] };

    if (user_country === "Canada")
      return { "currency": "CAD", "record": records["CAD"] };

    if (user_country === "Australia")
      return { "currency": "AUD", "record": records["AUD"] };

    if (user_country === "Russia")
      return { "currency": "RUB", "record": records["RUB"] };

    if (user_continent === "North America" || user_continent === "South America" || user_continent === "Central America")
      return { "currency": "USD", "record": records["USD"] };


    // No country geo ip match and no hashtag matched. Use page language
    if (this.props.language === "en")
      return { "currency": "USD", "record": records["USD"] };


    console.warn("Defaulting to EUR");

    // if (this.props.language === "es" || this.props.language === "fr" || this.props.language === "pt")
    return { "currency": "EUR", "record": records["EUR"] };


  }

  getCourseInfo = (slug, lan, voucher_code) => {

    axios
      .get(`https://www.10masters.com/webapi/course_landing/?slug=${slug}${voucher_code}&lang=${lan}`)
      .then(res => {

        if (slug !== res.data.slug) {
          console.warn("Hey, slug differs from received slug");
          //this.props.router.push(`/${this.props.language}/cursos/${res.data.slug}/`)
        }

        this.setState({
          product_id: res.data.product_id,
          page_title: res.data.page_title,
          course_title: res.data.title,
          course_teacher_name: res.data.teacher_name,
          course_type: res.data.course_type,
          teacher_bio: res.data.teacher_bio,
          teachers_bio: res.data.teachers_bio,
          packshot_image: res.data.packshot_image,
          number_lessons_text: res.data.number_lessons_text,
          audio_languages_text: res.data.audio_languages_text,
          under_price_text: res.data.under_price_text,
          under_price_animals_text: res.data.under_price_animals_text,
          course_level_text: res.data.course_level_text,
          subtitles_languages_text: res.data.subtitles_languages_text,
          under_action_button_text: res.data.under_action_button_text,
          course_has_certificate: res.data.course_has_certificate,
          artist_quote_text: res.data.artist_quote_text,
          artist_quote_name: res.data.artist_quote_name,
          cover_loop_mobile: res.data.cover_loop_mobile,
          cover_loop_mobile_image: res.data.cover_loop_mobile_image,
          cover_loop: res.data.cover_loop,
          cover_loop_image: res.data.cover_loop_image,
          cover_loop_video_mobile: res.data.cover_loop_video_mobile,
          cover_loop_video_subtitles_dir: res.data.cover_loop_video_subtitles_dir,
          cover_loop_video: res.data.cover_loop_video,
          course_undertitle_text: res.data.undertitle,
          intro_text: res.data.intro_text,
          intro_text_hidden: res.data.intro_text_hidden,
          outro_title: res.data.outro_title,
          outro_text: res.data.outro_text,
          outro_text_hidden: res.data.outro_text_hidden,
          course_section_blocks: JSON.parse(res.data.course_section_blocks),
          whats_included_list: JSON.parse(res.data.whats_included_list),
          whats_included_images: res.data.whats_included_images,
          faq_blocks: JSON.parse(res.data.faq_blocks),
          num_reviews: res.data.num_reviews,
          reviews_product_id: res.data.reviews_product_id,
          already_bought: res.data.already_bought,
          logged_in: res.data.logged_in,
          animals_discount: res.data.animals_discount,
          fb_event_id: res.data.fb_event_id,
          external_id: res.data.external_id,
          sponsors_image: res.data.sponsors_image,
          latest_works: res.data.latest_works,
          presale: res.data.presale,
          discount_message: res.data.discount_message,
          countdownRemainingTime: res.data.countdown_ending_date,
          is_realistic: res.data.is_realistic,
          value_eur: parseInt(res.data.product_records['EUR'].current_price.replace(/[^\d.]/g, '')),
          user_countrycode: res.data.user_countrycode,
          "page_loaded": true
        });


        function vanillaGetCookie (name) {
            let value = `; ${document.cookie}`;
            let parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }
        
        let consent_cookie = {};
        consent_cookie['analytics_storage'] = "denied";
        
        if ( vanillaGetCookie("cookies_consent") )
            consent_cookie = JSON.parse(decodeURIComponent(vanillaGetCookie("cookies_consent")));
        
        if (consent_cookie.analytics_storage == "granted") {

          console.info("Analytics_storage accepted.");
          
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-2R84YMS710');
    
          //window.pintrk('load', '2614234833498', { em: '<user_email_address>' });
          //window.pintrk('page');
          
          window.fbq('init', '527309371985437', {external_id: res.data.external_id});
    
          //let content_type = "product";

          //if (res.data.is_realistic === true) {
          //  window.fbq('init', '654387767265069', {external_id: res.data.external_id});
          //  content_type = "product"
          //}
          
          //if (res.data.is_realistic === false) {
          //  window.fbq('init', '1169560038195794');
          //  content_type = "non-realistic";
          //}

          const event_parameters = {product_id: res.data.product_id, content_type: "product", currency: 'EUR', value: parseInt(res.data.product_records['EUR'].current_price.replace(/[^\d.]/g, ''))};
    
          window.fbq('track', 'PageView', {}, {eventID: res.data.fb_event_id});
          window.fbq('trackCustom', 'PageView-beginners', {}, {eventID: res.data.fb_event_id+'CUSTOM'});
          window.fbq('track', 'ViewContent', event_parameters, {eventID: res.data.fb_event_id + 'CV'});

          //alert("SENT PageView & ViewContent");
          //alert(JSON.stringify(event_parameters));

        }


        if ( res.data.discount_message )
          this.mostrarPopupFuncion();

        let selected_record = this.selectRecord(res.data.product_records, res.data.user_country, res.data.user_continent);
        this.setState({
          current_price: selected_record.record.current_price,
          original_price: selected_record.record.original_price,
          product_currency: selected_record.currency
        });

        window.scrollTo(0, 0);

        const el = document.querySelector("meta[name='description']");
        el.setAttribute('content', res.data.search_description)

      })
      .catch(err => {
        console.error("Error loading" + err);
        let randomTime = Math.floor(Math.random() * 5);
        console.warn("Retrying in " + randomTime);
        //setTimeout(() => this.getCourseInfo(slug, this.props.language), randomTime * 1000);
        setTimeout(window.location.reload, randomTime * 1000);
      }).finally(err => {

        //this.setState({ "page_loaded": true });

      });

  };

  setCurrentSection(name) {

    this.setState({ current_section: name });

    let sname = name;

    if (sname === 'content')
      sname = 'scontent';

    if (sname === 'overview') {

      setTimeout(() => {
        const element = document.getElementById(sname);
        element.scrollIntoView({ behavior: 'smooth' });
      }, 100);

    } else {

      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 100);

    }

  }

  setTopPriceShown(yesno) {
    this.setState({ topPriceShown: yesno });
  }

  render() {

    return (
      <>
        {this.state.page_loaded &&
          <ConsentForm product_id={this.state.product_id} value_eur={this.state.value_eur} is_realistic={this.state.is_realistic} external_id={this.state.external_id} fb_event_id={this.state.fb_event_id} language={this.props.language} />
        }

        <Header logged_in={this.state.logged_in} language={this.props.language} />

        {/*<img className="w-100" src={this.getTrans('blackweek_banner')} alt="BLACKWEEK" />*/}

        <Popup
          open={this.state.mostrarPopup}
          closeOnDocumentClick={false}
          onClose={this.cerrarPopupFuncion}
        >
          {this.state.discount_message}
          <br />
          <br />
          <button onClick={this.cerrarPopupFuncion} className="course_info_toolbar_action_button mx-auto" href="#">OK</button>

        </Popup>

        <div className={`course_container ${!this.state.page_loaded ? 'course_page_not_loaded' : ''}`}>

          {
            this.state.isMobile &&
            <CourseLandingLoopVideo
                language={this.props.language}
                default_subtitles="no"
                loop={this.state.isLandscape ? this.state.cover_loop : this.state.cover_loop_mobile}
                loop_image={this.state.isLandscape ? this.state.cover_loop_image : this.state.cover_loop_mobile_image}
                video={this.state.isLandscape ? this.state.cover_loop_video : this.state.cover_loop_video_mobile}
                isLandscape={this.state.isLandscape}
                subtitles_dir={this.state.cover_loop_video_subtitles_dir}
                isMobile={true}
            />
          }


          <div className="row mt-0 mx-0 column-gap-30px">

            <div className="col-xl-4 gapwidth-col-xl-4 order-1 zindex-sticky padding_15_mobile">

              <div className="position-sticky sticky_price_desktop">
              {
              this.state.page_loaded &&
                <CourseInfo
                  is_realistic={this.state.is_realistic}
                  current_section={this.state.current_section}
                  setTopPriceShown={this.setTopPriceShown}
                  language={this.props.language}
                  already_bought={this.state.already_bought}
                  product_id={this.state.product_id}
                  product_currency={this.state.product_currency}
                  current_price={this.state.current_price}
                  original_price={this.state.original_price}
                  under_price_text={this.state.animals_discount ? this.state.under_price_animals_text : this.state.under_price_text}
                  under_action_button_text={this.state.under_action_button_text}
                  subtitles_languages_text={this.state.subtitles_languages_text}
                  course_level_text={this.state.course_level_text}
                  number_lessons_text={this.state.number_lessons_text}
                  course_has_certificate={this.state.course_has_certificate}
                  audio_languages_text={this.state.audio_languages_text}
                  isMobile={this.state.isMobile}
                  fb_event_id={this.state.fb_event_id}
                  external_id={this.state.external_id}
                  presale={this.state.presale}
                  countdownRemainingTime={this.state.countdownRemainingTime}
                  user_countrycode={this.state.user_countrycode}
                />
              }
              </div>

            </div>

            {
              this.state.isMobile &&
              <>
                <div className="col-xl-8 mr-lg-0 mr-3 order-0 p-0">
                  <div className={this.state.current_section !== 'overview' ? 'd-none' : ''}>
                    <CourseLandingHeaderInfo
                      course_title={this.state.course_title}
                      course_teacher_name={this.state.course_teacher_name}
                      language={this.props.language}
                      course_type={this.state.course_type}
                      undertitle_text={this.state.course_undertitle_text}
                    />
                  </div>
                </div>
              </>
            }


            <div className={`bg-black padding_15_mobile col-xl-8 mr-lg-0 mr-3 py-0 ${this.state.isMobile ? 'order-2' : 'order-0'}`}>

              {
                !this.state.isMobile &&
                <>
                  <div className={this.state.current_section !== 'overview' ? 'd-none' : ''}>
                    <CourseLandingLoopVideo
                      course_title={this.state.course_title}
                      course_type={this.state.course_type}
                      course_teacher_name={this.state.course_teacher_name}
                      language={this.props.language}
                      default_subtitles={this.props.language}
                      loop={this.state.isLandscape ? this.state.cover_loop : this.state.cover_loop_mobile}
                      loop_image={this.state.isLandscape ? this.state.cover_loop_image : this.state.cover_loop_mobile_image}
                      video={this.state.isLandscape ? this.state.cover_loop_video : this.state.cover_loop_video_mobile}
                      isLandscape={this.state.isLandscape}
                      subtitles_dir={this.state.cover_loop_video_subtitles_dir}
                      isMobile={false}
                      undertitle_text={this.state.course_undertitle_text}
                    />
                  </div>



                </>
              }

              <div className={this.state.current_section !== 'overview' ? 'd-none' : ''}>

                <br />

                {this.state.sponsors_image && 
                  <CourseLandingSponsors
                    show={true}
                    text={`${this.getTrans('sponsors_prefix')}${this.state.teacher_bio ? this.state.teacher_bio.name : ''}${this.getTrans('sponsors_sufix')}`}
                    image={this.state.sponsors_image}
                  />
                }

              </div>

              <a id="overview" style={{"scrollMarginTop": "25px"}} aria-hidden="true"></a>

              <div className={`position-sticky ${this.state.isMobile ? 'section_sticky_mobile' : 'top-0 section_sticky_desktop'}`}>
                <CourseSectionSelector
                  selector={this.setCurrentSection}
                  current_section={this.state.current_section}
                  language={this.props.language} mobile={this.state.isMobile}
                  presale={this.state.presale}
                />
              </div>

              <div className={this.state.current_section !== 'overview' ? 'd-none' : ''}>

                <br /><br />

                {/*<!--<CourseLandingQuote
                  title={this.state.artist_quote_text}
                  artist={this.state.artist_quote_name}
                />-->*/}

                <CourseLandingViewMore
                  language={this.props.language}
                  text={this.state.intro_text}
                  expanded_text={this.state.intro_text_hidden}
                />

                <br /><br />

                {/*<h5 className="text-white text-left sweet_sans mb-4">
                  {this.getTrans("lastworks")}
                </h5>*/}

                <CourseLandingImageGallery images={this.state.latest_works} numrows="3" mobile={this.state.isMobile} />

                <br />

                <h3 className="mt-4 mb-5 underlined_title mx-auto">{this.state.outro_title}</h3>

                <CourseLandingViewMore
                  language={this.props.language}
                  text={this.state.outro_text}
                  expanded_text={this.state.outro_text_hidden}
                />

                {
                  this.state.whats_included_list &&

                  <CourseLandingWhatsIncluded
                    whats_included_list={this.state.whats_included_list}
                    whats_included_images={this.state.whats_included_images}
                    language={this.props.language}
                    mobile={this.state.isMobile}
                  />
                }



                {
                  //!this.state.reveal_sections &&
                  <a className="mb-4 d-block text-decoration-none sweet_sans cursor-pointer text-nowrap get_all_content_font" onClick={() => this.setCurrentSection('scontent')}>{this.getTrans('get_all_content')} 
                    <svg style={{marginLeft: '5px', marginTop: '-3.5px'}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </a>

                }


                <CourseFeaturesList language={this.props.language} packshot_image={this.state.packshot_image} />

                <CourseLandingTeachers language={this.props.language} teachers={this.state.teachers_bio} />

                {/*

                <HubInfo current_price={this.state.current_price}
                  original_price={this.state.original_price}
                  language={this.props.language}
                  />

                <br />
                <br />
                */}

                <UnderlinedTitle className="made_outer_sans_regular" text={this.getTrans("faq_title")} />

                {
                  this.state.faq_blocks.map((faq, index) =>
                    <CourseFAQ
                      key={index}
                      question={faq.value.question}
                      answer={faq.value.answer}
                      isExpanded={this.state.expandedIndex === index}
                      onClick={() => this.handleExpand(index)}
                    />
                  )
                }

                {
                  ! this.state.presale &&
                  <>
                    <br />
                    <UnderlinedTitle text={this.getTrans("highlighted_reviews")} />
                  </>
                }

                {
                  this.state.reviews_product_id &&
                  <HighlightedCourseReviews selector={this.setCurrentSection} language={this.props.language} id={this.state.reviews_product_id} />
                }
              </div>


              <div className={this.state.current_section !== 'scontent' ? 'd-none' : 'mt-2'}>
                <a className="mobile_section_margin" id="scontent"></a>

                {
                  //this.state.reveal_sections &&
                  this.state.course_section_blocks.map((section, index) =>
                    <CourseLandingContentSection
                      key={section.value.title}
                      title={section.value.title}
                      is_new={section.value.is_new}
                      is_updated={section.value.is_updated}
                      loop={this.state.isMobile ? `https://newcdn.10masters.com${section.value.mobile_loop}` : `https://newcdn.10masters.com${section.value.loop}`}
                      loop_image={this.state.isMobile ? section.value.mobile_loop_image : section.value.loop_image}
                      loop_text={section.value.loop_text}
                      text={section.value.content}
                      expanded_text={section.value.hidden_content}
                      language={this.props.language}
                      number={index < 9 ? "0" + (index+1) : index+1}
                    />
                  )
                }


                <CourseLandingCertificate language={this.props.language} />

              </div>


              <div className={this.state.current_section !== 'reviews' ? 'd-none' : 'padding_15_mobile bg-black'}>

                <a className="mobile_section_margin" id="reviews"></a>

                <UnderlinedTitle className="made_outer_sans_regular" text={this.getTrans("ratings_title")} />

                <div className="course_landing_reviews_text" dangerouslySetInnerHTML={{ __html: this.getTrans("course_landing_reviews_text") }}></div>

                {
                  this.state.num_reviews &&
                  <CourseReviews
                    language={this.props.language}
                    reviews_product_id={this.state.reviews_product_id}
                    num_reviews={this.state.num_reviews}
                  />
                }
              </div>

            
            </div>

          </div>

        </div>

        <Footer language={this.props.language} slug={this.props.params.courseSlug} />

      </>
    );

  }
}

export default withRouter(CourseLanding);
